import { Fixture } from "../models/Fixture";
import TeamLogo from "./TeamLogo";
import { FixtureCard } from "./styles/FixturesCard.Styles";

const FixturesCard = (props: {fixture: Fixture}) => {
    return (
        <FixtureCard key={`${props.fixture.date}-${props.fixture.homeTeam}-${props.fixture.awayTeam}`}>
        <div className="team">
          <div className="logo-container">
            <TeamLogo team={props.fixture.homeTeam} width="60px" height="60px" />
          </div>
          <h3>{props.fixture.homeTeam}</h3>
        </div>
        
        <div className="details">
          <div className="date">{new Date(props.fixture.date).toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}</div>
          <div className="time">{props.fixture.time}</div>
          <div className="venue">{props.fixture.venue}</div>
        </div>
        
        <div className="team">
          <div className="logo-container">
            <TeamLogo team={props.fixture.awayTeam} width="60px" height="60px" />
          </div>
          <h3>{props.fixture.awayTeam}</h3>
        </div>
      </FixtureCard>)
}

export default FixturesCard;